import { render, staticRenderFns } from "./BatchEditRoleDialog.vue?vue&type=template&id=65028943&scoped=true"
import script from "./BatchEditRoleDialog.vue?vue&type=script&lang=ts"
export * from "./BatchEditRoleDialog.vue?vue&type=script&lang=ts"
import style0 from "./BatchEditRoleDialog.vue?vue&type=style&index=0&id=65028943&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65028943",
  null
  
)

export default component.exports